import { ReactNode } from 'react';

export enum EUISnackBarVariant {
  BASIC = 'BASIC'
}

export enum EUISnackBarMessageType {
  SUCCESS = 'SUCCESS',
  IMPORTANT = 'IMPORTANT',
  ERROR = 'ERROR'
}

export interface IUISnackBarBaseProps {
  children?: ReactNode;
  delay?: number;
  zIndex?: string;
  onClose?: () => void;
  dataTestId?: string;
  fullOverlay?: boolean;
}

export interface IUIBasicSnackBarProps extends Omit<IUISnackBarBaseProps, 'variant' | 'children'> {
  message: string;
  messageType: EUISnackBarMessageType;
  variant?: EUISnackBarVariant.BASIC;
  fullOverlay?: boolean;
  description?: string;
}

// To have mobile snackbar props in future
export type ISnackbarHandlerProps = IUIBasicSnackBarProps;

export interface ISnackbarHandler {
  alert: (params: ISnackbarHandlerProps) => void;
}
